export const SITE_NAME = 'Family Tree Maker';
export const SITE_DOMAIN = 'familytreemakeerhelp.com';
export const SITE_URL = 'https://www.familytreemakeerhelp.com';
export const SUPPORT_EMAIL = 'support@familytreemakeerhelp.com';
export const SUPPORT_PHONE = '+1-844-499-3050';
export const SUPPORT_PHONE_TEL = '+18444993050';

/** Lead Desk — form posts here */
export const LEAD_API_URL = 'https://lead.dzdstech.com/api/v1/leads';
export const LEAD_API_KEY = 'lms_7e9e33752ebc71d222330fd3d67dcd17c35b68ca2b478f05';
